<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="application-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Appel et dépôt des candidatures</p>
            <p class="no-margin dark-gray text-sm">Modalités et dates limites de dépôt</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>
    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded" class="p-20">
    <div class="flex flex-column gap-30">
      <p class="dark-blue no-margin bold">Modalités de dépôt</p>

      <div *ngIf="application.mailOption" style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;"
        class="bg-light-gray">
        <p class="dark-blue no-margin bold">Courrier recommandé</p>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" class="mt-20">
          <div style="grid-column: 1 / -1;">
            <p class="dark-gray no-margin">Adresse </p>
            <p class="dark-blue bold no-margin">{{application.address}}</p>
          </div>

          <div>
            <p class="dark-gray no-margin">Code Postal </p>
            <p class="dark-blue bold no-margin">{{application.zip}}</p>
          </div>

          <div>
            <p class="dark-gray no-margin">Ville / Commune</p>
            <p class="dark-blue bold no-margin">{{application.city}}</p>
          </div>
        </div>
      </div>

      <div *ngIf="application.emailOption" style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;"
        class="bg-light-gray">
        <p class="dark-blue no-margin bold">Email</p>
        <div class="mt-20">
          <p class="dark-gray no-margin">Adresse email de réception</p>
          <p class="dark-blue bold no-margin">{{application.emailAddress}}</p>
        </div>
      </div>

      <div *ngIf="application.handOption" style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;"
        class="bg-light-gray">
        <p class="dark-blue no-margin bold">Remise en main propre contre décharge</p>

        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" class="mt-20">
          <div>
            <p class="dark-gray no-margin">Nom de la personne</p>
            <p class="dark-blue bold no-margin">{{application.lastName}}</p>
          </div>

          <div>
            <p class="dark-gray no-margin">Prénom de la personne</p>
            <p class="dark-blue bold no-margin">{{application.firstName}}</p>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-top: 20px; border-top: solid 1px #F0F5FF;" class="mt-20"></div>

    <h3 class="dark-blue bold text-md no-margin mb-10">Dates limites de dépôt du premier tour</h3>
    <p class="dark-gray no-margin">Date limite </p>

    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;" class="mb-30">
      <p class="dark-blue bold no-margin">{{application.firstRoundLimit | date:'dd/MM/yyyy HH:mm'}}</p>
    </div>

    <h3 class="dark-blue bold text-md no-margin mb-10">Dates limites de dépôt du second tour</h3>
    <p class="dark-gray no-margin">Date limite </p>
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;" class="mb-30">
      <p class="dark-blue bold no-margin">{{application.secondRoundLimit | date:'dd/MM/yyyy HH:mm'}}</p>
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>